if (!customElements.get('nrx-steps')) {
    class NRXSteps extends HTMLElement {
        connectedCallback() {
            const progressFill =
                this.querySelector('.js-nrx-steps-fill');

            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (!entry.isIntersecting) return;

                        requestAnimationFrame(() => {
                            progressFill.style.transform = 'scale(1)';
                        });

                        observer.disconnect();
                    });
                },
                {
                    threshold: 0.3
                }
            );

            observer.observe(this);
        }
    }
    customElements.define('nrx-steps', NRXSteps);
}